import METADATA from 'src/constants/metadata';

const AuthorJsonLd = (props: any) => {
	const { article } = props;
	const educations = !article?.educations ? [''] :article?.educations?.map((data: any) => {
		return data.university;
	});

	const AuthorJson1 = {
		'@context': 'https://schema.org',
		'@type': 'Organization',
		name: 'Hallobumil',
		url: METADATA.WEB_URL,
		logo: METADATA.WEB_URL + '/hallobumil-logo.png',
	};

	const AuthorJson3 = {
		'@context': 'https://schema.org',
		'@type': 'Person',

		colleague: educations,
		image: article?.media_path || '/images/author/author.png',
		jobTitle: article?.title,
		name: article?.name,
		url: METADATA.WEB_URL+`/author/${article?.slug}`,
	};

	return (
		<>
			<script
				defer
				id="author"
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: JSON.stringify(AuthorJson1) }}
			/>

			<script
				defer
				id="author"
				type="application/ld+json"
				// nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
				dangerouslySetInnerHTML={{ __html: JSON.stringify(AuthorJson3) }}
			/>
		</>
	);
};

export default AuthorJsonLd;
